/* eslint-disable */
import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import "./styles/Modal.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider
    clientId={`${process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID}`}
  >
    <App />
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
